import React from 'react'
import "./Privacy.css"
import { useTranslate } from '../../Context/LanguageContext';


const PrivacyPolicy = () => {
    const t = useTranslate("privacy-policy")

    return ( 
        <div id='privacy-policy'>
            <h1>{t("title")}</h1>
            <p>{t("declaration")}</p>

            <div className='article'>
                <h2>{t("article1")}</h2>
                <p>{t("article1-p")}</p>
                <p>Waldstr. 14</p>
                <p>{t("article1-phone") + ": +49 (8102) 8961680"}</p>
                <p>{t("article1-fax") + ": +49 (8102) 8961699"}</p>
                <p>{t("article1-mail") + ": kanzlei@birnthaler.com"}</p>
            </div>

            <div className='article'>
                <h2>{t("article2")}</h2>
                <h3>{t("article2-1title")}</h3>
                <p>{t("article2-1")}</p>
                <h3>{t("article2-2title")}</h3>
                <p>{t("article2-2")}</p>
                <h3>{t("article2-3title")}</h3>
                <p>{t("article2-3")}</p>
            </div>

            <div className='article'>
                <h2>{t("article3")}</h2>
                <h3>{t("article3-1title")}</h3>
                <p>{t("article3-1")}</p>
                <p>{t("article3-1-1")}</p>
                <p>{t("article3-1-2")}</p>
                <p>{t("article3-1-3")}</p>
                <p>{t("article3-1-4")}</p>
                <p>{t("article3-1-5")}</p>
                <p>{t("article3-1-6")}</p>
                <p>{t("article3-1-7")}</p>
                <p>{t("article3-1-8")}</p>
                <h3>{t("article3-2title")}</h3>
                <p>{t("article3-2")}</p>
                <h3>{t("article3-3title")}</h3>
                <p>{t("article3-3")}</p>
                <h3>{t("article3-4title")}</h3>
                <p>{t("article3-4")}</p>
                <h3>{t("article3-5title")}</h3>
                <p>{t("article3-5")}</p>
            </div>

            <div className='article'>
                <h2>{t("article4")}</h2>
                <h3>{t("article4-1title")}</h3>
                <p>{t("article4-1")}</p>
            </div>

            <div className='article'>
                <h2>{t("article5")}</h2>
                <h3>{t("article5-1title")}</h3>
                <p>{t("article5-1")}</p>
                <h3>{t("article5-2title")}</h3>
                <p>{t("article5-2")}</p>
                <h3>{t("article5-3title")}</h3>
                <p>{t("article5-3")}</p>
                <h3>{t("article5-4title")}</h3>
                <p>{t("article5-4")}</p>
                <h3>{t("article5-5title")}</h3>
                <p>{t("article5-5")}</p>
            </div>

            <div className='article'>
                <h2>{t("article6")}</h2>
                <p>{t("article6-pre")}</p>
                <h3>{t("article6-1title")}</h3>
                <p>{t("article6-1")}</p>
                <p>{t("article6-1-1")}</p>
                <p>{t("article6-1-2")}</p>
                <p>{t("article6-1-3")}</p>
                <p>{t("article6-1-4")}</p>
                <p>{t("article6-1-5")}</p>
                <p>{t("article6-1-6")}</p>
                <p>{t("article6-1-7")}</p>
                <p>{t("article6-1-8")}</p>
                <p>{t("article6-1-9")}</p>

                <h3>{t("article6-2title")}</h3>
                <p>{t("article6-2")}</p>

                <h3>{t("article6-3title")}</h3>
                <p>{t("article6-3")}</p>
                <p>{t("article6-3-1")}</p>
                <p>{t("article6-3-2")}</p>
                <p>{t("article6-3-3")}</p>
                <p>{t("article6-3-4")}</p>
                <p>{t("article6-3-5")}</p>

                <h3>{t("article6-4title")}</h3>
                <h3>{t("article6-4-1title")}</h3>
                <p>{t("article6-4-1")}</p>
                <p>{t("article6-4-1-1")}</p>
                <p>{t("article6-4-1-2")}</p>
                <p>{t("article6-4-1-3")}</p>
                <p>{t("article6-4-1-4")}</p>
                <p>{t("article6-4-1-5")}</p>
                <p>{t("article6-4-1-6")}</p>

                <h3>{t("article6-4-2title")}</h3>
                <p>{t("article6-4-2")}</p>

                <h3>{t("article6-4-3title")}</h3>
                <p>{t("article6-4-3")}</p>
                <p>{t("article6-4-3-1")}</p>
                <p>{t("article6-4-3-2")}</p>
                <p>{t("article6-4-3-3")}</p>
                <p>{t("article6-4-3-4")}</p>
                <p>{t("article6-4-3-5")}</p>

                <h3>{t("article6-5title")}</h3>
                <p>{t("article6-5")}</p>

                <h3>{t("article6-6title")}</h3>
                <p>{t("article6-6")}</p>
                <p>{t("article6-6-1")}</p>
                <p>{t("article6-6-2")}</p>
                <p>{t("article6-6-3")}</p>

                <h3>{t("article6-7title")}</h3>
                <p>{t("article6-7")}</p>
                <h3>{t("article6-8title")}</h3>
                <p>{t("article6-8")}</p>

                <h3>{t("article6-9title")}</h3>
                <p>{t("article6-9")}</p>
                <p>{t("article6-9-1")}</p>
                <p>{t("article6-9-2")}</p>
                <p>{t("article6-9-3")}</p>
                <p>{t("article6-9-4")}</p>

                <h3>{t("article6-10title")}</h3>
                <p>{t("article6-10")}</p>
                <a target='_' href='https://www.bfdi.bund.de/DE/Service/Anschriften/anschriften_table.html'>www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html</a>
                <h3>{t("article6-11title")}</h3>
                <p>{t("article6-11")}</p>
            </div>
        </div>
     );
}
 
export default PrivacyPolicy;